import { render, staticRenderFns } from "./myRadio.vue?vue&type=template&id=627933be&scoped=true&"
import script from "./myRadio.vue?vue&type=script&lang=js&"
export * from "./myRadio.vue?vue&type=script&lang=js&"
import style0 from "./myRadio.vue?vue&type=style&index=0&id=627933be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627933be",
  null
  
)

export default component.exports